import { z } from 'zod';
import { entierOuNull, decimalOuNull, texteFacultatif } from './champs';

/**
 * Schéma de la charge utile envoyée à la création d'un capteur.
 *
 * Prudence assumée sur ce formulaire : aucun de ses champs ne porte
 * aujourd'hui de required, de type ni de pattern, et rien n'y est validé. Le
 * schéma se limite donc à ce qui est certain, et laisse le reste facultatif
 * plutôt que de risquer de bloquer des créations qui passent actuellement.
 *
 * Sept champs de ce formulaire arrivaient à NaN quand ils n'étaient pas
 * renseignés, parce que la charge utile est construite avec parseInt ou
 * parseFloat sur des valeurs initialisées à null. Les briques entierOuNull et
 * decimalOuNull ramènent cela à null, ce qui est ce que l'API recevait déjà
 * après sérialisation, mais désormais intentionnellement.
 */
export const schemaNouveauCapteur = z.object({
  // Un capteur sans nom n'est pas exploitable dans les listes ni les graphes.
  sensor_name: z
    .string({ message: 'saisir_un_nom_de_capteur' })
    .trim()
    .min(1, { message: 'saisir_un_nom_de_capteur' }),

  // Rattachements : facultatifs ici, faute de certitude sur ce que l'API
  // accepte. À resserrer une fois le comportement confirmé côté serveur.
  project_id: entierOuNull,
  type_id: entierOuNull,
  import_filter_id: entierOuNull,
  emailgroup_id: entierOuNull,

  // Coordonnées : décimales, facultatives, virgule décimale non gérée ici
  // puisque les champs sont libres et que rien ne la convertit aujourd'hui.
  coordinate_x: decimalOuNull,
  coordinate_y: decimalOuNull,
  coordinate_z: decimalOuNull,

  watchdog: entierOuNull,

  sensors_group: texteFacultatif,
  remarks: texteFacultatif,
  format_date: texteFacultatif,
  path_ascii_file: texteFacultatif,
  position: texteFacultatif,
  time_zone: texteFacultatif,

  active: entierOuNull,
  sensor_projection: entierOuNull,
  criticite_id: entierOuNull,

  component_list: z.array(z.any(), { message: 'valeur_invalide' }),
});

/**
 * Schéma de la charge utile envoyée à la modification d'un capteur.
 *
 * Même contrat que la création, plus l'identifiant du capteur visé. L'écran
 * de profil sert aussi à dupliquer un capteur : la duplication passe par le
 * chemin de création et réutilise donc directement schemaNouveauCapteur.
 */
export const schemaModificationCapteur = schemaNouveauCapteur.extend({
  sensor_id: z.coerce.number({ message: 'valeur_invalide' }).int(),
});
